import { Link } from 'react-router-dom';
import type { FeaturedChannel } from '../lib/api';

export function ChannelStrip({ channels }: { channels: FeaturedChannel[] }) {
  if (!channels.length) return null;
  return (
    <section aria-label="Highlighted creator channels" className="channel-strip">
      {channels.map((ch) => {
        const username = ch.owner?.username ?? ch.slug;
        const assets = ch.previewAssets ?? ch.assets ?? [];
        return (
          <article key={ch.id} className="channel-card">
            <div className="creator-row">
              <span className="avatar">{(ch.name ?? '?').slice(0, 1)}</span>
              <div>
                <h3>{ch.name}</h3>
                <div className="muted">@{username}</div>
              </div>
            </div>
            <p className="muted" style={{ margin: '0.4rem 0 0', fontSize: '0.85rem' }}>
              {ch.description ?? 'Published work'}
            </p>
            <div className="channel-previews">
              {assets.slice(0, 3).map((a) => (
                <Link key={a.id} to={`/spin/${a.id}`} aria-label={a.title}>
                  <img src={a.posterUrl ?? undefined} alt="" />
                </Link>
              ))}
            </div>
          </article>
        );
      })}
    </section>
  );
}
